import { render, staticRenderFns } from "./NotificationAttachments.vue?vue&type=template&id=13247f54&scoped=true&"
import script from "./NotificationAttachments.vue?vue&type=script&lang=ts&"
export * from "./NotificationAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationAttachments.vue?vue&type=style&index=0&id=13247f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13247f54",
  null
  
)

export default component.exports